module.exports = __webpack_public_path__ + "img/img-ticket-chat.6397710f.png";